/** @jsx isolateComponent */

import { Fragment } from 'react';
import { Button } from '@zapier/design-system';
import {
  isolateComponent,
  labelStyles,
} from '@zapier/common-utils';
import { loginPath, signupPath } from '@zapier/universal-nav/dist/constants';

import UniversalTopbarLink from './UniversalTopbarLink';

type Props = {
  /**
   * `Href` to login button.
   */
  loginHref: string;
  /**
   * Currently navigated to url.
   */
  selectedHref: string;
  /**
   * Indicates whether Log in button should render.
   */
  shouldRenderSignIn: boolean;
  /**
   * Indicates whether Sign up button should render.
   */
  shouldRenderSignUp: boolean;
  /**
   * The size of the component, which influences the size of its buttons.
   */
  size: 'small' | 'medium';
  /**
   * `Href` to signup button.
   */
  signupHref: string;
};

const Styles = labelStyles(__filename, {
  signupButton: {
    minWidth: 100,
  }
});

/**
 * Conditionally renders a login link and sign up button.
 */
export const AccountActions = (props: Props) => {
  return (
    <Fragment>
      {props.shouldRenderSignIn && (
        <UniversalTopbarLink
          href={props.loginHref}
          isSelected={props.selectedHref.includes(props.loginHref)}
        >
          Log in
        </UniversalTopbarLink>
      )}
      {props.shouldRenderSignUp && (
        <div css={Styles.signupButton}>
          <Button
            color="blue"
            hasShadow={true}
            href={props.signupHref}
            id="universalnav-signup"
            isFullWidth={true}
            size="small"
          >
            Sign up
          </Button>
        </div>
      )}
    </Fragment>
  );
};

AccountActions.defaultProps = {
  loginHref: loginPath,
  selectedHref: '',
  signupHref: signupPath,
  size: 'medium',
};

export default AccountActions;
